// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"a25f6694","475":"fa920286","578":"d651827d","787":"5cf25b8f"}[chunkId] + ".chunk.js";
};